import { css } from '@emotion/react';
import { Link } from 'react-router-dom';

const HeaderTab = ({ selected, path, label }) => {
    return (
        <li
            css={css`
                list-style: none;
            `}
        >
            <Link
                css={({ orangeDefault, white }) => css`
                    box-sizing: border-box;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                    font-size: 1.6666rem;
                    border-top: solid 8px transparent;
                    border-bottom: solid 8px ${selected ? orangeDefault : 'transparent'};
                    color: ${selected ? orangeDefault : white};
                    font-weight: ${selected ? 'bold' : 'normal'};
                    text-decoration: none;

                    &:hover,
                    &:focus-visible {
                        color: ${orangeDefault};
                    }

                    &:focus-visible {
                        outline: solid;
                        outline-width: 2px;
                        outline-color: ${white};
                        outline-offset: -2px;
                    }
                `}
                to={path}
            >
                {label}
            </Link>
        </li>
    );
};
export default HeaderTab;
